import {
  LikeRestaurant,
  LikeRestaurantVariables
} from '../../../../../types/graphql-types-generated.ts';
import { AppContext } from '../../../../../components/app-context/app-context.tsx';
import { IGraphQLQueryError } from '../../../../../components/graphql/graphql-service.ts';
import { GqlQuery } from '../../../../../components/graphql/gql-tag.ts';
import { gql } from 'graphql-request';

const gqlScript: GqlQuery = {
  gqlQuery: gql`
    mutation LikeRestaurant($restaurantId: ID!) {
      saveRestaurantLike(input: { userId: null, restaurantId: $restaurantId })
    }
  `
};
export const likeRestaurant = (variables: LikeRestaurantVariables, appContext: AppContext) =>
  appContext.graphqlService.query<LikeRestaurant, IGraphQLQueryError>({
    query: gqlScript,
    variables
  });
